// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actions-tracker {
  background: var(--color-card-bg);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tracker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.tracker-header h2 {
  font-size: 20px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
}

:root[data-theme='light'] .tracker-header h2 {
  color: #1e3a8a;
}

.header-controls {
  display: flex;
  gap: 8px;
}

.header-controls button {
  background: var(--color-card-bg);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

:root[data-theme='light'] .header-controls button {
  color: #1e3a8a;
}

.header-controls button:hover {
  background: var(--color-hover-bg);
  border-color: var(--color-border-hover);
}

.tracker-toolbar {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.filter-tabs {
  display: flex;
  gap: 0;
  background: var(--color-bg-secondary);
  border-radius: 6px;
  padding: 2px;
}

.filter-tab {
  background: transparent;
  border: none;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-secondary);
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
}

:root[data-theme='light'] .filter-tab {
  color: #1e3a8a;
}

.filter-tab:hover {
  color: var(--color-text-primary);
}

:root[data-theme='light'] .filter-tab:hover {
  color: #1e3a8a;
  font-weight: 600;
}

.filter-tab.active {
  background: var(--color-card-bg);
  color: var(--color-primary);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

:root[data-theme='light'] .filter-tab.active {
  color: #1e3a8a;
  font-weight: 700;
}

.add-task-btn {
  background: var(--color-primary);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.add-task-btn:hover {
  background: var(--color-primary-dark);
}

.tracker-columns {
  flex: 1 1;
  overflow-y: auto;
}

.column-headers {
  display: grid;
  grid-template-columns: 2.5fr 1fr 1fr 1fr 1fr 0.8fr 0.5fr;
  gap: 16px;
  padding: 12px 16px;
  background: var(--color-bg-secondary);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: sticky;
  top: 0;
  z-index: 10;
}

:root[data-theme='light'] .column-headers {
  color: #1e3a8a;
}

.column-headers > div.sortable {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: color 0.2s;
}

.column-headers > div.sortable:hover {
  color: #007bff;
}

.sort-icon {
  font-size: 10px;
  opacity: 0.6;
}

.actions-sections {
  margin-top: 16px;
}

.action-section {
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.section-toggle {
  color: var(--color-text-secondary);
  font-size: 12px;
}

.section-title {
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 14px;
}

:root[data-theme='light'] .section-title {
  color: #1e3a8a;
}

.section-actions {
  margin-top: 8px;
  position: relative;
  overflow: hidden;
}

.action-row {
  display: grid;
  grid-template-columns: 2.5fr 1fr 1fr 1fr 1fr 0.8fr 0.5fr;
  gap: 16px;
  padding: 12px 16px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  margin-bottom: 8px;
  background: var(--color-card-bg);
  transition: all 0.2s;
  align-items: center;
}

.action-row:hover {
  border-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
}

.action-row.completing {
  animation: completeHighlight 0.8s ease-out;
  transition: all 0.3s ease-out;
}

@keyframes completeHighlight {
  0% {
    background: var(--color-card-bg);
    transform: scale(1);
  }
  30% {
    background: rgba(255, 107, 53, 0.15);
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.2);
  }
  60% {
    background: rgba(255, 107, 53, 0.1);
    transform: scale(1.01);
    box-shadow: 0 2px 8px rgba(255, 107, 53, 0.15);
  }
  100% {
    background: rgba(255, 107, 53, 0.05);
    transform: translateX(10px) scale(0.98);
    opacity: 0.8;
  }
}

.action-row {
  transition: all 0.3s ease-out;
}

.column-name {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  border-radius: 50%;
  appearance: none;
  -webkit-appearance: none;
  border: 2px solid #1a365d;
  background: var(--color-card-bg);
  position: relative;
  transition: all 0.2s;
}

.action-checkbox:checked {
  background: #ff6b35;
  border-color: #1a365d;
}

.action-checkbox:checked::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.action-text {
  font-size: 14px;
  color: var(--color-text-primary);
  line-height: 1.4;
}

:root[data-theme='light'] .action-text {
  color: #1e3a8a;
}

.action-text.completed {
  text-decoration: line-through;
  color: #999;
}

:root[data-theme='light'] .action-text.completed {
  color: #94a3b8;
}

.column-due {
  display: flex;
  align-items: center;
  justify-content: center;
}

.due-date {
  font-size: 13px;
  color: var(--color-text-secondary);
}

:root[data-theme='light'] .due-date {
  color: #1e3a8a;
}

.column-project {
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-name {
  font-size: 13px;
  color: var(--color-text-primary);
  background: var(--color-bg-secondary);
  padding: 4px 8px;
  border-radius: 4px;
}

:root[data-theme='light'] .project-name {
  color: #1e3a8a;
}

.column-assignee {
  display: flex;
  align-items: center;
  justify-content: center;
}

.assignee-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 13px;
  background: var(--color-card-bg);
  color: var(--color-text-primary);
  cursor: pointer;
  text-align: center;
}

:root[data-theme='light'] .assignee-select {
  color: #1e3a8a;
}

.assignee-select:hover {
  border-color: #007bff;
}

.column-overall {
  display: flex;
  align-items: center;
  justify-content: center;
}

.overall-status {
  font-size: 13px;
  color: var(--color-text-secondary);
}

:root[data-theme='light'] .overall-status {
  color: #1e3a8a;
}

.status-button {
  font-size: 13px;
  font-weight: 500;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  background: var(--color-card-bg);
  transition: all 0.2s ease;
  border: 1px solid var(--color-border);
  width: 100%;
  text-align: center;
  letter-spacing: -0.01em;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif;
}

.status-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
}

.column-priority {
  display: flex;
  align-items: center;
  justify-content: center;
}

.priority-badge {
  font-size: 11px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  cursor: pointer;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif;
}

.priority-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
}

.add-task-section-btn {
  width: 100%;
  padding: 8px;
  border: 1px dashed var(--color-border);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.2s;
}

:root[data-theme='light'] .add-task-section-btn {
  color: #1e3a8a;
}

.add-task-section-btn:hover {
  border-color: #007bff;
  color: #007bff;
  background: rgba(0, 123, 255, 0.1);
}

:root[data-theme='light'] .add-task-section-btn:hover {
  border-color: #1e3a8a;
  color: #1e3a8a;
  background: rgba(30, 58, 138, 0.1);
}

/* Dropdown styles */
.status-dropdown-container,
.priority-dropdown-container {
  position: relative;
}

.dropdown-arrow {
  font-size: 7px;
  margin-left: 3px;
  opacity: 0.3;
  transition: all 0.2s;
  display: inline-block;
}

.status-button:hover .dropdown-arrow,
.priority-badge:hover .dropdown-arrow {
  opacity: 0.5;
  transform: translateY(1px);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  margin-top: 0;
  background: var(--color-card-bg);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  overflow: hidden;
  min-width: 120px;
  max-width: 150px;
  animation: dropdownFadeIn 0.15s ease-out;
  padding: 4px;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.dropdown-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.01em;
  transition: all 0.15s ease;
  position: relative;
  border-radius: 4px;
  margin-bottom: 2px;
  text-align: center;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  line-height: 1;
}

.dropdown-item:last-child {
  margin-bottom: 0;
}

.dropdown-item:hover {
  transform: scale(1.02);
  filter: brightness(0.95);
}

.priority-item {
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.03em;
  font-weight: 600;
  padding: 6px 12px;
  height: 32px;
  line-height: 1;
}

.status-button,
.priority-badge {
  position: relative;
}

.status-button {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.status-menu {
  min-width: 130px;
  max-width: 150px;
}

.priority-menu {
  min-width: 100px;
  max-width: 120px;
}

.dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
  transform: none;
  filter: none;
}

/* Override the previous hover styles */

/* Delete button styles */
.column-delete {
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
  opacity: 0.2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-button:hover {
  opacity: 1;
  background: rgba(40, 167, 255, 0.1);
}

.delete-button svg {
  width: 16px;
  height: 16px;
  transition: all 0.2s ease;
}

.delete-button:hover svg {
  fill: #2196f3;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .column-headers,
  .action-row {
    grid-template-columns: 2fr 1fr 1.5fr 1fr 1fr 0.8fr;
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .column-headers {
    display: none;
  }
  
  .action-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .action-row > div {
    display: flex;
    justify-content: space-between;
  }
  
  .action-row > div::before {
    content: attr(data-label);
    font-weight: 600;
    color: #666;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ActionsTracker.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,MAAM;EACN,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE;IACE,gCAAgC;IAChC,mBAAmB;EACrB;EACA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,8CAA8C;EAChD;EACA;IACE,mCAAmC;IACnC,sBAAsB;IACtB,8CAA8C;EAChD;EACA;IACE,oCAAoC;IACpC,uCAAuC;IACvC,YAAY;EACd;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,qFAAqF;AACvF;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,qFAAqF;AACvF;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,YAAY;AACd;;AAEA,uCAAuC;;AAEvC,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,kDAAkD;IAClD,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".actions-tracker {\n  background: var(--color-card-bg);\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.tracker-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.tracker-header h2 {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n:root[data-theme='light'] .tracker-header h2 {\n  color: #1e3a8a;\n}\n\n.header-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.header-controls button {\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n:root[data-theme='light'] .header-controls button {\n  color: #1e3a8a;\n}\n\n.header-controls button:hover {\n  background: var(--color-hover-bg);\n  border-color: var(--color-border-hover);\n}\n\n.tracker-toolbar {\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 0;\n  background: var(--color-bg-secondary);\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.filter-tab {\n  background: transparent;\n  border: none;\n  padding: 6px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n:root[data-theme='light'] .filter-tab {\n  color: #1e3a8a;\n}\n\n.filter-tab:hover {\n  color: var(--color-text-primary);\n}\n\n:root[data-theme='light'] .filter-tab:hover {\n  color: #1e3a8a;\n  font-weight: 600;\n}\n\n.filter-tab.active {\n  background: var(--color-card-bg);\n  color: var(--color-primary);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n:root[data-theme='light'] .filter-tab.active {\n  color: #1e3a8a;\n  font-weight: 700;\n}\n\n.add-task-btn {\n  background: var(--color-primary);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.add-task-btn:hover {\n  background: var(--color-primary-dark);\n}\n\n.tracker-columns {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.column-headers {\n  display: grid;\n  grid-template-columns: 2.5fr 1fr 1fr 1fr 1fr 0.8fr 0.5fr;\n  gap: 16px;\n  padding: 12px 16px;\n  background: var(--color-bg-secondary);\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n:root[data-theme='light'] .column-headers {\n  color: #1e3a8a;\n}\n\n.column-headers > div.sortable {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  transition: color 0.2s;\n}\n\n.column-headers > div.sortable:hover {\n  color: #007bff;\n}\n\n.sort-icon {\n  font-size: 10px;\n  opacity: 0.6;\n}\n\n.actions-sections {\n  margin-top: 16px;\n}\n\n.action-section {\n  margin-bottom: 24px;\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n  cursor: pointer;\n  user-select: none;\n}\n\n.section-toggle {\n  color: var(--color-text-secondary);\n  font-size: 12px;\n}\n\n.section-title {\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-size: 14px;\n}\n\n:root[data-theme='light'] .section-title {\n  color: #1e3a8a;\n}\n\n.section-actions {\n  margin-top: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.action-row {\n  display: grid;\n  grid-template-columns: 2.5fr 1fr 1fr 1fr 1fr 0.8fr 0.5fr;\n  gap: 16px;\n  padding: 12px 16px;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  margin-bottom: 8px;\n  background: var(--color-card-bg);\n  transition: all 0.2s;\n  align-items: center;\n}\n\n.action-row:hover {\n  border-color: #007bff;\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);\n}\n\n.action-row.completing {\n  animation: completeHighlight 0.8s ease-out;\n  transition: all 0.3s ease-out;\n}\n\n@keyframes completeHighlight {\n  0% {\n    background: var(--color-card-bg);\n    transform: scale(1);\n  }\n  30% {\n    background: rgba(255, 107, 53, 0.15);\n    transform: scale(1.02);\n    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.2);\n  }\n  60% {\n    background: rgba(255, 107, 53, 0.1);\n    transform: scale(1.01);\n    box-shadow: 0 2px 8px rgba(255, 107, 53, 0.15);\n  }\n  100% {\n    background: rgba(255, 107, 53, 0.05);\n    transform: translateX(10px) scale(0.98);\n    opacity: 0.8;\n  }\n}\n\n.action-row {\n  transition: all 0.3s ease-out;\n}\n\n.column-name {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.action-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  border-radius: 50%;\n  appearance: none;\n  -webkit-appearance: none;\n  border: 2px solid #1a365d;\n  background: var(--color-card-bg);\n  position: relative;\n  transition: all 0.2s;\n}\n\n.action-checkbox:checked {\n  background: #ff6b35;\n  border-color: #1a365d;\n}\n\n.action-checkbox:checked::after {\n  content: '✓';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.action-text {\n  font-size: 14px;\n  color: var(--color-text-primary);\n  line-height: 1.4;\n}\n\n:root[data-theme='light'] .action-text {\n  color: #1e3a8a;\n}\n\n.action-text.completed {\n  text-decoration: line-through;\n  color: #999;\n}\n\n:root[data-theme='light'] .action-text.completed {\n  color: #94a3b8;\n}\n\n.column-due {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.due-date {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n:root[data-theme='light'] .due-date {\n  color: #1e3a8a;\n}\n\n.column-project {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.project-name {\n  font-size: 13px;\n  color: var(--color-text-primary);\n  background: var(--color-bg-secondary);\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n:root[data-theme='light'] .project-name {\n  color: #1e3a8a;\n}\n\n.column-assignee {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.assignee-select {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-size: 13px;\n  background: var(--color-card-bg);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  text-align: center;\n}\n\n:root[data-theme='light'] .assignee-select {\n  color: #1e3a8a;\n}\n\n.assignee-select:hover {\n  border-color: #007bff;\n}\n\n.column-overall {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.overall-status {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n:root[data-theme='light'] .overall-status {\n  color: #1e3a8a;\n}\n\n.status-button {\n  font-size: 13px;\n  font-weight: 500;\n  padding: 6px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  background: var(--color-card-bg);\n  transition: all 0.2s ease;\n  border: 1px solid var(--color-border);\n  width: 100%;\n  text-align: center;\n  letter-spacing: -0.01em;\n  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif;\n}\n\n.status-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);\n}\n\n.column-priority {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.priority-badge {\n  font-size: 11px;\n  font-weight: 500;\n  padding: 5px 10px;\n  border-radius: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  cursor: pointer;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: all 0.2s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif;\n}\n\n.priority-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);\n}\n\n.add-task-section-btn {\n  width: 100%;\n  padding: 8px;\n  border: 1px dashed var(--color-border);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-top: 8px;\n  transition: all 0.2s;\n}\n\n:root[data-theme='light'] .add-task-section-btn {\n  color: #1e3a8a;\n}\n\n.add-task-section-btn:hover {\n  border-color: #007bff;\n  color: #007bff;\n  background: rgba(0, 123, 255, 0.1);\n}\n\n:root[data-theme='light'] .add-task-section-btn:hover {\n  border-color: #1e3a8a;\n  color: #1e3a8a;\n  background: rgba(30, 58, 138, 0.1);\n}\n\n/* Dropdown styles */\n.status-dropdown-container,\n.priority-dropdown-container {\n  position: relative;\n}\n\n.dropdown-arrow {\n  font-size: 7px;\n  margin-left: 3px;\n  opacity: 0.3;\n  transition: all 0.2s;\n  display: inline-block;\n}\n\n.status-button:hover .dropdown-arrow,\n.priority-badge:hover .dropdown-arrow {\n  opacity: 0.5;\n  transform: translateY(1px);\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: 0;\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n  overflow: hidden;\n  min-width: 120px;\n  max-width: 150px;\n  animation: dropdownFadeIn 0.15s ease-out;\n  padding: 4px;\n}\n\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-2px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.dropdown-item {\n  padding: 6px 12px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  transition: all 0.15s ease;\n  position: relative;\n  border-radius: 4px;\n  margin-bottom: 2px;\n  text-align: center;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  line-height: 1;\n}\n\n.dropdown-item:last-child {\n  margin-bottom: 0;\n}\n\n.dropdown-item:hover {\n  transform: scale(1.02);\n  filter: brightness(0.95);\n}\n\n.priority-item {\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 0.03em;\n  font-weight: 600;\n  padding: 6px 12px;\n  height: 32px;\n  line-height: 1;\n}\n\n.status-button,\n.priority-badge {\n  position: relative;\n}\n\n.status-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.status-menu {\n  min-width: 130px;\n  max-width: 150px;\n}\n\n.priority-menu {\n  min-width: 100px;\n  max-width: 120px;\n}\n\n.dropdown-item:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n  transform: none;\n  filter: none;\n}\n\n/* Override the previous hover styles */\n\n/* Delete button styles */\n.column-delete {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  opacity: 0.2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-button:hover {\n  opacity: 1;\n  background: rgba(40, 167, 255, 0.1);\n}\n\n.delete-button svg {\n  width: 16px;\n  height: 16px;\n  transition: all 0.2s ease;\n}\n\n.delete-button:hover svg {\n  fill: #2196f3;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .column-headers,\n  .action-row {\n    grid-template-columns: 2fr 1fr 1.5fr 1fr 1fr 0.8fr;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .column-headers {\n    display: none;\n  }\n  \n  .action-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  \n  .action-row > div {\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .action-row > div::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #666;\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
